import React, {useState} from 'react';
import I18n from '../../languages/I18n';
//import {useDispatch, useSelector} from 'react-redux';

const SearchBeachInput = props => {
  const [beaches_results, setBeachesResults] = useState([]);

  const onChangeTxt = e => {
    searchBeaches(e.target.value);
  };

  const clearSearch = () => {
    document.getElementById('search-beach-form').value = '';
    setBeachesResults([]);
  };

  const openBeach = beach => {
    clearSearch();
    props.openBeach(beach);
  };

  const searchBeaches = text => {
    var tmp = text
      .trim()
      .toUpperCase()
      //.normalize('NFD')
      //.replace(/[\u0300-\u036f]/g, '')
      ;

    var newBeaches = [];
    if (tmp !== '' && props.beaches_list) {
      props.beaches_list.forEach(beach => {
        if (
          beach.name
            .trim()
            .toUpperCase()
            //.normalize('NFD')
            //.replace(/[\u0300-\u036f]/g, '')
            .includes(tmp) ||
          beach.city
            .trim()
            .toUpperCase()
            //.normalize('NFD')
            //.replace(/[\u0300-\u036f]/g, '')
            .includes(tmp)
        ) {
          newBeaches.push(beach);
        }
      });
    }
    setBeachesResults(newBeaches);
  };

  return (

    <>
    <div style={{
      position: 'absolute',
      zIndex: 11,
      top: 30,
      left: props.isSmall ? '5%' : 30,
      width: props.isSmall ? '90%' : 550,
      maxWidth: '90%',
    }}>

      <div
        style={{
          width: '100%',
          height: 60,
          borderRadius: 65,
          backgroundColor: '#fff',
          color: '#333',
          WebkitBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
          MozBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
          boxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <img
          style={{
            width: 30,
            height: 30,
            marginRight: 20,
            marginLeft: 22,
          }}
          alt="locate"
          src={require('../../assets/icons/set_ico-search.png')}
        />
        <div style={{flex: 1}}>
          <input
            id="search-beach-form"
            className="searchInput"
            type="text"
            autoComplete="off"
            placeholder={I18n.t('beaches_list.search_beach')}
            onChange={(e) => onChangeTxt(e)}
          />
        </div>
      </div>

      {beaches_results.length > 0 && (
        <div
          style={{
            marginTop: 10,
            width: '100%',
            borderRadius: 10,
            backgroundColor: '#fff',
            color: '#333',
            WebkitBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
            MozBoxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
            boxShadow: '2px 3px 5px 0px rgba(0,0,0,0.19)',
            overflowY: 'scroll',
            overflowX: 'hidden',
            maxHeight: 160
          }}>
          {beaches_results.map((item, i) => (

            <div
              className="listBtn"
              onClick={() => openBeach(item)}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: 7,
                paddingBottom: 5,
                flex: 1,
              }}
              key={'BEACHLIST' + item.id}
              anchor="center">
              <img
                style={{width: 15, marginLeft: 15, marginRight: 10}}
                alt="geolocation"
                src={require('../../assets/icons/set_ico-carte.png')}
              />
              <div style={{flex: 1}}>
                {`${item.name} (${item.city})`}
              </div>
            </div>
          ))}
        </div>
      )}


      </div>
      {beaches_results.length > 0 && (
        <div
          onClick={clearSearch}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10,
            backgroundColor: 'RGBA(0,0,0,0.1)',
            maxWidth: '100%',
            width: '100%',
            height: '100%',
          }}></div>
      )}


</>



  );
};

export default SearchBeachInput;
